
import Banner from "../components/Banner/Banner";
import CV from "../components/CV/CV";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Skills from "../components/Skills/Skills";
import Works from "../components/Works/Works";

function Home(){
    return(
        <>
    <Header/>
    <Banner/>
    <CV/>
    <Skills/>
    <Works />
    <Contact />
    <Footer />
    </>
    );
}
export default Home;